// Translation: Login > Landing > Form (English)
export default Object.freeze({
	form: {
		actions: {
			login: {
				label: 'Login'
			}
		},
		fields: {
			code: {
				placeholder: 'Enter code'
			},
			email: {
				placeholder: 'Enter your email'
			},
			password: {
				placeholder: 'Enter your password'
			}
		},
		options: {
			register: {
				action: 'Register',
				label: 'Need an account?'
			},
			reset: {
				action: 'Forgot password?'
			}
		},
		title: {
			credentials: 'Account login',
			twoFactorAuthentication: 'Two-factor authentication'
		}
	}
})
